import React, { Component } from 'react'
import PropTypes from 'prop-types';
import SpinnerIcon from '../../../../common/components/SpinnerIcon'
import { ActionIcons, CallBtn, CallHandlingBox, Decline, IconRow } from '../styles/dialpadstyle'
import { Button } from 'modules/theme';
export class CallHandlerTheme extends Component {
  btnLogic( ringing, callState ) {
    /*
      button state
      0 - Disabled
      1 - Enable
      2 - Loading
    */
    let result = {
      "muteBtn" : 1,
      "holdBtn" : 1,
      "transferBtn" : 1,
      "endBtn" : 1,
    }
    if( ringing ){
      result.muteBtn = 0;
      result.holdBtn = 0;
      result.transferBtn = 0;
      if( callState == "endLoading" ){
        result.endBtn = 2;
      } else {
        result.endBtn = 1;
      }
    } else if( callState ){
      result.muteBtn = 0;
      result.holdBtn = 0;
      result.transferBtn = 0;
      result.endBtn = 1;
      if( callState == "mute" ){
        result.muteBtn = 1;
      } else if( callState == "hold" ){
        result.holdBtn = 1;
      } else if( callState == "transfer" ){
        result.transferBtn = 1;
      } else if( callState == "muteLoading" ){
        result.muteBtn = 2;
      } else if( callState == "holdLoading" ){
        result.holdBtn = 2;
      } else if( callState == "transferLoading" ){
        result.transferBtn = 2;
      } else if( callState == "endLoading" ){
        result.endBtn = 2;
      }
    } else {
      result.muteBtn = 1;
      result.holdBtn = 1;
      result.transferBtn = 1;
      result.endBtn = 1;
    }
    return result;
  }
  mouseCss( state ) {
    if( state == 1 ){
      return { cursor:"pointer"}
    } else {
      return { cursor:"not-allowed"}
    }
  }
  callingEvent( state, event ) {
    if( state == 1 ){
      return event
    } else {
      return ()=>{
        console.log("Event Restricted");
      }
    }
  }
  iconRender( state, icon ) {
    if( state == 2 ){
      return <SpinnerIcon />
    } else {
      return icon
    }
  }
  render() {
    const {
      forceClose = true,
      ringing,
      callState,
      onClickFuncMute,
      labelNameMute,
      iconMute,
      onClickFuncHold,
      labelNameHold,
      iconHold,
      onClickFuncKeypad,
      labelNameKeypad,
      iconKeypad,
      onClickFuncTag,
      labelNameTag,
      iconTag,
      onClickFuncAddCall,
      labelNameAddCall,
      iconAddCall,
      onClickFuncInfo,
      labelNameInfo,
      iconInfo,
      onClickBtn,
      btn
    } = this.props;
    let btnState = this.btnLogic( ringing, callState );
    console.log("btnState", btnState, ringing, callState);
    return (
      <div style={{height: "100%"}}>
        <CallHandlingBox style={{height: "100%", marginTop: 60}}>
          <IconRow>
            <ActionIcons>
              <a style={ this.mouseCss( btnState.muteBtn )}  onClick={ this.callingEvent( btnState.muteBtn, onClickFuncMute) }>
                  {this.iconRender(btnState.muteBtn, iconMute)}
                <label>{labelNameMute}</label>
              </a>
            </ActionIcons>
            <ActionIcons>
            <a style={ this.mouseCss( btnState.holdBtn )}  onClick={ this.callingEvent( btnState.holdBtn, onClickFuncHold) }>
                {this.iconRender(btnState.holdBtn, iconHold)}
              <label>{labelNameHold}</label>
            </a>
            </ActionIcons>
            <ActionIcons>
              <a style={{cursor: ringing ? "not-allowed" : "pointer"}}  onClick={ !ringing ? onClickFuncKeypad :()=>{}}>
                  {iconKeypad}
                <label>{labelNameKeypad}</label>
              </a>
            </ActionIcons>
          </IconRow>
          <IconRow>
            <ActionIcons>
              <a style={{cursor: ringing ? "not-allowed" : "pointer"}}  onClick={ !ringing ? onClickFuncTag :()=>{}}>
                  {iconTag}
                <label>{labelNameTag}</label>
              </a>
            </ActionIcons>
            <ActionIcons>
              <a style={ this.mouseCss( btnState.transferBtn )}  onClick={ this.callingEvent( btnState.transferBtn, onClickFuncAddCall) }>
                {this.iconRender(btnState.transferBtn, iconAddCall)}
                <label>{labelNameAddCall}</label>
              </a>
            </ActionIcons>
            <ActionIcons>
              {/* <a style={{cursor: ringing ? "not-allowed" : "pointer"}} onClick={ !ringing ? onClickFuncInfo :""}> */}
              <a style={{cursor:"pointer"}} onClick={ onClickFuncInfo }>
                  {iconInfo}
                <label>{labelNameInfo}</label>
              </a>
            </ActionIcons>
          </IconRow>
          <CallBtn>
            <Decline style={{width: '100%'}}>
              <a style={ this.mouseCss( btnState.endBtn )}  onClick={ this.callingEvent( btnState.endBtn, onClickBtn) }>
                <i>
                  {this.iconRender(btnState.endBtn, <img src={btn} />)}
                </i>
              </a>
            </Decline>
          </CallBtn>
          {/* <div className="circle">
            <img src="/images/BiDialpadAlt.png" style={{ padding: '13px' }} />
          </div>
          <div className="circle">
            <img
              onClick={this.callHoldToggle}
              src="/images/AiOutlineUserAdd.png"
            />
          </div>
          <div className="circle">
            <img
              onClick={this.callMuteToggle}
              src="/images/AiOutlinePause.png"
            />
          </div>
          <div className="circle">
            <img src="/images/MdEditNote.png" />
          </div> */}
        </CallHandlingBox>
        {/* <CallBtn>
          <button className="" onClick={this.callHangup}>
            End
          </button>
        </CallBtn> */}
      </div>
    )
  }
}

CallHandlerTheme.contextTypes = {
  __: PropTypes.func
};

export default CallHandlerTheme


// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/CallHandlerTheme.js